var render = function render(){var _vm=this,_c=_vm._self._c;return _c('crud-modal',{attrs:{"title":_vm.$t('modals.ambassador.updateTitle'),"action":"update","on-submit":_vm.submit,"on-close":_vm.close,"valdiation-scope":"ambassador"}},[_c('ambassador-form',{attrs:{"ambassador":_vm.ambassador}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }